import GridCollection from './GridCollection/GridCollection'
import { useDispatch, useSelector } from 'react-redux'
import cls from './CollectionPage.module.scss'
import {
    getAcceptedMoments,
    getRejectedMoments,
    getWantedMoments,
} from 'features/anonymousAuth'
import { useCallback, useEffect, useRef, useState } from 'react'
import { ButtonProfile } from 'widgets/ButtonProfile/ButtonProfile'
import { CollectionContainer } from './CollectionContainer/CollectionContainer'
import { navActions } from 'entities/NavMenu'
import { useNavigate, useParams } from 'react-router-dom'
import { Text, TextColor, TextSize, TextWeight } from 'shared/ui/Text/Text'
import { Button } from 'shared/ui/Button'
import { CopyIcon, MoreIcon, ShareIcon } from 'shared/ui/Icon'
import { DragDrop } from 'widgets/DragDrop/DragDrop'
import OtherProfilePage from './OtherProfilePage/OtherProfilePage'
import { Popup } from 'shared/ui/Popup/Popup'
import { copyTextToClipboard } from 'shared/lib/copyTextToTextClipboard/copyTextToTextClipboard'
import { AnnounceFloat } from './AnnounceFloat/AnnounceFloat'
import {
    getAcceptedCardData,
    getCreatedCardData,
    getSelectCardsInCollection,
    getWantedCardData,
} from 'app/providers/LoadDataProvider/ui/selectors'
import { WantContainer } from './WantContainer/WantContainer'
import React from 'react'
import { AccountEmailBanner } from 'features/emailAuth'
import { copyApplicationLink } from 'shared/lib/copyApplicationLink/copyApplicationLink'
import { getAgent } from 'features/modeLogic'
import { ProfileInstallBanner } from 'features/pwaInstall'
import { ImageWithSkeleton } from 'shared/ui/ImageWithSkeleton'

const CollectionPage = ({ installPrompt, onInstallPromptHandled }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const announceCollections = useSelector(
        (state) => state.collection.announceCollections
    )

    const parsedCollections = useSelector(getSelectCardsInCollection)

    const { id } = useParams()

    const userId = useSelector((state) => state.auth.id)
    const name = useSelector((state) => state.auth.name)
    const avatar = useSelector((state) => state.auth.avatar)
    const descr = useSelector((state) => state.auth.descr)
    const nickname = useSelector((state) => state.auth.nickname)
    const background = useSelector((state) => state.auth.background)
    const agent = useSelector(getAgent)

    const [showAnnounceFloat, setShowAnnounceFloat] = useState(false)

    const [switcher, setSwitcher] = useState(null)
    const [, setFixedHeader] = useState(true)
    const [dragdrop, setDragdrop] = useState(false)

    const [visible, setVisible] = useState(false)
    const [popupText, setPopupText] = useState('Ник скопирован')

    const [secondSwitcher, setSecondSwitcher] = useState(null)
    const [accountLinked, setAccountLinked] = useState(false)
    const [accountBannerKey, setAccountBannerKey] = useState(0)

    const handleAccountStateChange = useCallback((state) => {
        setAccountLinked(state === 'linked')
    }, [])

    useEffect(() => {
        const secondSwitcher = sessionStorage.getItem('secondSwitcher')

        if (secondSwitcher) {
            setSecondSwitcher(secondSwitcher)
        } else {
            sessionStorage.setItem('secondSwitcher', 'want')
            setSecondSwitcher('want')
        }
    }, [])

    useEffect(() => {
        if (String(id) === String(userId)) {
            dispatch(navActions.setVisible(true))
        }
        if (id === nickname) {
            dispatch(navActions.setVisible(true))
        }
    }, [dispatch, id, nickname, userId])

    const wantedCardData = useSelector(getWantedCardData)
    const acceptedCardData = useSelector(getAcceptedCardData)
    const createdCardData = useSelector(getCreatedCardData)

    const myAcceptedMoments = useSelector(getAcceptedMoments) // для баннера снизу
    const myWantedMoments = useSelector(getWantedMoments)
    const myRejectedMoments = useSelector(getRejectedMoments)
    const myAllMoments = myAcceptedMoments.concat(
        myWantedMoments,
        myRejectedMoments
    )

    let header

    if (switcher === 'accepted') {
        header = 'Достигнуто'
    } else if (switcher === 'created') {
        header = 'Создано'
    }

    const counterCreate = createdCardData.length
    // let counterAccept = acceptedCardData.length

    const onToggleWant = () => {
        setSecondSwitcher('want')
        sessionStorage.setItem('secondSwitcher', 'want')
    }

    const onToggleCol = () => {
        setSecondSwitcher('collection')
        sessionStorage.setItem('secondSwitcher', 'collection')
    }

    const onSwitchCreated = () => {
        setSwitcher('created')
        setFixedHeader(true)
    }

    const onSwitchAccepted = () => {
        setSwitcher('accepted')
        setFixedHeader(true)
    }

    const onSwitchBack = () => {
        setSwitcher(null)
        setFixedHeader(true)
        dispatch(navActions.setVisible(true))
    }

    const closeDragdrop = () => {
        setTimeout(() => {
            setDragdrop(false)
        }, 100)
    }

    const timeoutWhaleCopyRef = useRef(null) // реф для таймаута говорящего кита
    const onSpeak = useCallback((text = 'Ник скопирован') => {
        // ф-ция говорящего кита
        clearTimeout(timeoutWhaleCopyRef.current)
        timeoutWhaleCopyRef.current = null
        setPopupText(text)
        setVisible(true)
        timeoutWhaleCopyRef.current = setTimeout(() => {
            setVisible(false)
        }, 1000)
    }, [])

    if (String(userId) !== String(id)) {
        if (id !== nickname) {
            return <OtherProfilePage />
        }
    }

    const navigateToSettings = () => {
        navigate('/settings')
    }

    const copyText = (text) => {
        copyTextToClipboard(text)
        onSpeak()
    }

    const copyAppLink = () => {
        onSpeak(copyApplicationLink())
    }

    const closeAnnounceFloat = () => {
        setShowAnnounceFloat(false)
    }

    const navigateToSuggest = () => {
        navigate('/suggest')
    }

    const openAnnounceFloat = () => {
        setShowAnnounceFloat(true)
    }

    return (
        <>
            <AnnounceFloat
                closeAnnounceFloat={closeAnnounceFloat}
                navigateToSuggest={navigateToSuggest}
                open={showAnnounceFloat}
            />
            <div className={cls.CollectionPage}>
                <Popup visible={visible} text={popupText} />
                {!switcher ? (
                    <div className={cls.ProfileContainer}>
                        <Button
                            className={cls.ShareButton}
                            onClick={copyAppLink}
                            ariaLabel="Скопировать ссылку на MineCards"
                        >
                            <ShareIcon className={cls.Share} />
                        </Button>
                        <Button
                            onClick={() => setDragdrop(!dragdrop)}
                            className={cls.Settings}
                        >
                            <MoreIcon />
                        </Button>
                        <ImageWithSkeleton
                            className={cls.background}
                            alt="background"
                            src={background}
                        />
                        <ImageWithSkeleton
                            onClick={navigateToSettings}
                            className={cls.Avatar}
                            alt="avatar"
                            src={avatar}
                        />
                        <Text
                            className={cls.name}
                            size={TextSize.L}
                            weight={TextWeight.BOLD}
                        >
                            {name === 'Мечтатель'
                                ? 'Здесь будет твоё имя'
                                : name}
                        </Text>
                        <Text
                            onClick={() =>
                                copyText(nickname ? `@${nickname}` : `@${id}`)
                            }
                            className={cls.nickname}
                            size={TextSize.S}
                            color={TextColor.TERBLACK}
                        >
                            <div className={cls.nicknameContent}>
                                {nickname ? `@${nickname}` : `@${id}`}
                                <CopyIcon className={cls.nicknameCopyIcon} />
                            </div>
                        </Text>
                        <Text
                            className={cls.description}
                            weight={TextWeight.REG}
                        >
                            {descr !== null
                                ? descr
                                : 'А тут твой текст. Настрой свой профиль через меню сверху'}
                        </Text>
                    </div>
                ) : null}
                {!switcher ? (
                    <AccountEmailBanner
                        key={accountBannerKey}
                        onAccountChanged={(result) => {
                            navigate(`/${result.profileId}`, { replace: true })
                        }}
                        onAccountStateChange={handleAccountStateChange}
                    />
                ) : null}
                {!switcher ? (
                    <ButtonProfile
                        className={cls.ButtonProfile}
                        counterAccept={acceptedCardData.length}
                        onSwitchAccepted={onSwitchAccepted}
                        counterWant={counterCreate}
                        onSwitchWanted={onSwitchCreated}
                        secondSwitcher={secondSwitcher}
                        onToggleWant={onToggleWant}
                        onToggleCol={onToggleCol}
                    />
                ) : null}
                {!switcher ? (
                    <ProfileInstallBanner
                        installPrompt={installPrompt}
                        onInstallPromptHandled={onInstallPromptHandled}
                        platform={agent}
                    />
                ) : null}
                {switcher === 'created' ? (
                    <GridCollection
                        collection={createdCardData}
                        switcher={switcher}
                        header={header}
                        counterAccept={acceptedCardData.length}
                        counterWant={counterCreate}
                        onSwitchBack={onSwitchBack}
                    />
                ) : null}
                {switcher === 'accepted' ? (
                    <GridCollection
                        collection={acceptedCardData}
                        switcher={switcher}
                        header={header}
                        counterAccept={acceptedCardData.length}
                        counterWant={counterCreate}
                        onSwitchBack={onSwitchBack}
                    />
                ) : null}
                {!switcher ? (
                    <>
                        {secondSwitcher === 'collection' ? (
                            <CollectionContainer
                                className={cls.CollectionContainer}
                                collections={parsedCollections}
                                announceCollections={announceCollections}
                                openAnnounceFloat={openAnnounceFloat}
                            />
                        ) : (
                            <WantContainer
                                myAllMoments={myAllMoments}
                                wantedCardData={wantedCardData}
                            />
                        )}
                    </>
                ) : null}
                {dragdrop ? (
                    <DragDrop
                        accountLinked={accountLinked}
                        closeDragdrop={closeDragdrop}
                        nickname={nickname}
                        id={userId}
                        onAccountChanged={(result) => {
                            if (result.loggedOut) {
                                navigate('/', { replace: true })
                            } else {
                                navigate(`/${result.profileId}`, {
                                    replace: true,
                                })
                            }
                        }}
                        onAccountLinked={() => {
                            setAccountLinked(true)
                            setAccountBannerKey((key) => key + 1)
                        }}
                        onSpeak={onSpeak}
                    />
                ) : null}
            </div>
        </>
    )
}

export default CollectionPage
